import React from 'react';
import { useTranslation } from 'react-i18next';
import SettingTitle from '../../../common/components/UI/Title/SettingTitle';

const Header = () => {
    const { t } = useTranslation('archive', { keyPrefix: 'header' });
    return (
        <SettingTitle
            subtitleText={t('adminPageSubHeader')}
            titleText={t('adminPageHeader')}
            reverse={true}
        />
    )
}

export default Header;